import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "family-portfolio-summary",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "portfolio-family" */ "./components"),
    ])
      .then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
      .catch(err => {
        return err;
      })
  ),
});
